import React, { useState } from 'react'
import { BtnV2, Link, l, Modal } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { openManageProfilesModal as openManageProfilesModalAction } from 'common/core/actions/uiActions'
import { MetaDeletionPayload } from 'common/core/components/NotifyBar/NotifyInterfaces'

import cm from './common.module.css'

interface MetaDeletionSignInNotificationProps {
  day: 0 | 15 | 27
  data: MetaDeletionPayload
}

export const MetaDeletionSignInNotification = ({
  day,
  data,
}: MetaDeletionSignInNotificationProps) => {
  const dispatch = useAppDispatch()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const hangleToggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }
  const openManageProfilesModal = () => {
    dispatch(openManageProfilesModalAction())
    setIsModalOpen(false)
  }

  return (
    <>
      <span className="m-r-xs">
        {l.translate('Facebook sign-in will be removed on {deletion_date}', {
          deletion_date: l.date(data.deletion_date),
        })}
      </span>

      <Link className={cm.link} onClick={hangleToggleModal}>
        {l.translate('Read more')}
      </Link>

      <Modal
        width={460}
        title={l.translate('Add another sign-in method')}
        open={isModalOpen}
        buttons={[
          <BtnV2 variant="primary" onClick={openManageProfilesModal}>
            {l.translate('Review sign-in options')}
          </BtnV2>,
        ]}
        onRequestClose={hangleToggleModal}
      >
        {day === 0 && (
          <>
            <p className="font-medium">
              {l.translate('Facebook sign-in will be removed on <b>{deletion_date}</b>.', {
                deletion_date: l.date(data.deletion_date),
              })}
            </p>
            <p>
              {l.translate(
                "It's your only sign-in method and may already be unavailable. Your email isn't verified. Add another sign-in method now. If you can't add one, ask support now.",
              )}
            </p>
          </>
        )}

        {day === 15 && (
          <>
            <p className="font-medium">
              {l.translate('Facebook sign-in will still be removed on <b>{deletion_date}</b>.', {
                deletion_date: l.date(data.deletion_date),
              })}
            </p>
            <p>
              {l.translate(
                "It's still your only sign-in method and may already be unavailable. Add another sign-in method now. If you can't add one, ask support now.",
              )}
            </p>
          </>
        )}

        {day === 27 && (
          <>
            <p className="font-medium">
              {l.translate(
                'Final notice: Facebook sign-in will be removed on <b>{deletion_date}</b>.',
                {
                  deletion_date: l.date(data.deletion_date),
                },
              )}
            </p>
            <p>
              {l.translate(
                "It may already be unavailable. Add another sign-in method now. Can't add one? Ask support now.",
              )}
            </p>
          </>
        )}
      </Modal>
    </>
  )
}
